document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-fq-item]').forEach(function (item) {
    var toggle = item.querySelector('[data-fq-toggle]');
    var answer = item.querySelector('[data-fq-answer]');
    if (!toggle || !answer) return;

    toggle.addEventListener('click', function () {
      var isOpen = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      if (isOpen) {
        answer.setAttribute('hidden', '');
      } else {
        answer.removeAttribute('hidden');
      }
    });
  });
});
